import React, { useEffect } from 'react';

const CustomAlert = ({ type, message, onClose }) => {
  const bgColor = type === 'error' ? 'bg-red-100' : 'bg-green-100';
  const textColor = type === 'error' ? 'text-red-700' : 'text-green-700';
  const borderColor = type === 'error' ? 'border-red-400' : 'border-green-400';

  // Close the alert automatically after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(); // Close alert after 3 seconds
    }, 4000);

    // Clean up the timer when the component is unmounted
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`${bgColor} border ${borderColor} ${textColor} my-[10px] px-4 py-3 rounded relative`}
      role="alert"
    >
      <span className="block sm:inline">{message}</span>
      {onClose && (
        <span
          className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer"
          onClick={onClose}
        >
          <svg
            className={`fill-current h-6 w-6 ${textColor}`}
            role="button"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title>Close</title>
            <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
          </svg>
        </span>
      )}
    </div>
  );
};

export default CustomAlert;
